module.exports = __webpack_public_path__ + "static/solo-text-bg-621eadd4ec057d7add5dc8926897fbd7.svg";